import Share from './share'

export type { ShareProps } from './share'

export { Share }
